(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_f916ab1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sn-support')) {
    customElements.define('sn-support', class extends HTMLElement {
      connectedCallback() {
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        this._outside = event => { if (details.open && !this.contains(event.target)) details.open = false; };
        this._escape = event => { if (event.key === 'Escape' && details.open) { details.open = false; summary.focus(); } };
        this.querySelector('.sn-support__close').addEventListener('click', () => { details.open = false; summary.focus(); });
        document.addEventListener('click', this._outside);
        document.addEventListener('keydown', this._escape);
      }
      disconnectedCallback() {
        document.removeEventListener('click', this._outside);
        document.removeEventListener('keydown', this._escape);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
